import React, {useState, useRef, useEffect} from 'react';
import axios from 'axios';
import "./UploadSingleFile.css"
import {useLocation} from "react-router-dom";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import {Button, Checkbox, FormControlLabel, TextField} from "@mui/material";
import {IoIosCloseCircle} from "react-icons/io";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import CaseFilesInternal from "../../enums/CaseFilesInternal";
import CaseFilesStatus from "../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import {jwtDecode} from "jwt-decode";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";

const UploadSingleFile = ({onClose, onFileUpload, caseData, isCaseCreatedByExpert = false, users}) => {
    const [file, setFile] = useState(null);
    const [additionalInfo, setAdditionalInfo] = useState('');
    const [shared, setShared] = useState(false);
    const [fileTitle, setFileTitle] = useState("");
    const [approveDoc, setApproveDoc] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const fileInputRef = useRef(null);
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const [roleId, setRoleId] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const sendNotification = async (fileId) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.createdFile.id,
            caseStatus: 8,
            viewed: true,

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.type !== 'application/pdf') {
                setAlert({show: true, message: 'შეცდომა: ატვირთეთ მხოლოდ PDF ფაილები.', type: 'error'});
                setFile(null);
            } else {
                setFile(selectedFile);
                setAlert({...alert, show: false});
            }
        }
    };


    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.key === "Escape") {
                onClose();
            }
        }

        function handleClickOutside(event) {
            if (event.target.classList.contains('upload-single-popup')) {
                onClose();
            }
        }

        document.addEventListener('keydown', handleEscapeKey);
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
            document.removeEventListener('click', handleClickOutside);
        };
    }, [onClose]);


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });

    const performUpload = async () => {
        if (!file) {
            return;
        }

        setIsUploading(true);
        const fileBase64 = await toBase64(file);


        const fileData = {
            caseID: caseId,
            name: fileTitle,
            ext: file.name.split('.').pop(),
            file: fileBase64,
            mainInfo: "",
            additionalInfo: additionalInfo,
            shared: isCaseCreatedByExpert ? shared : false,
            sharedTemp: shared,
            blank: false,
            documentType: 0,
            internal: isCaseCreatedByExpert ? CaseFilesInternal.Yes : CaseFilesInternal.No,
            status: isCaseCreatedByExpert ? CaseFilesStatus.SentForVisage : CaseFilesStatus.ReadyForVisage,
            decline: CaseFileDeclined.No,
            isUploaded: true,
            approvalDocument: approveDoc,
            declinedInternalStatus: 0
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData);
            await sendNotification(response.data.resultId)
            setAlert({show: true, message: 'დოკუმენტი აიტვირთა წარმატებით!', type: 'success'});

        } catch (error) {
            setAlert({show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგივანევბით!', type: 'error'});
        }
        setIsUploading(false);
        setIsModalOpen(false);
        onFileUpload();
        onClose();
    };

    return (
        <div>
            <div className="upload-single-popup">
                <div className="upload-single-container">
                    <IoIosCloseCircle className="upload-single-close-icon" onClick={onClose}>Close</IoIosCloseCircle>
                    <div className="upload-single-header">
                        <p className="upload-single-title">დოკუმენტის ატვირთვა</p>
                    </div>
                    <div className="upload-single-body">
                        <Button variant="contained" onClick={() => fileInputRef.current.click()}
                                className="upload-single-button">
                            აირჩიეთ ფაილი
                        </Button>
                        <input
                            type="file"
                            accept=".pdf"
                            ref={fileInputRef}
                            style={{display: 'none'}}
                            onChange={handleFileChange}
                        />
                        {file && <div className="upload-single-selected-file">{file.name}</div>}
                        <TextField
                            label="ფაილის სახელი"
                            variant="outlined"
                            type="text"

                            value={fileTitle}
                            onChange={(e) => setFileTitle(e.target.value)}
                        />
                        <TextField
                            placeholder="დამატებითი აღწერა"
                            variant="outlined"
                            multiline
                            rows={10}
                            maxRows={50}
                            value={additionalInfo}
                            onChange={(e) => setAdditionalInfo(e.target.value)}
                        />
                        <div className={"upload-single-checkbox-group"}>
                            <FormControlLabel
                                control={<Checkbox checked={shared} onChange={(e) => setShared(e.target.checked)}/>}
                                label="საჯარო"
                                disabled={approveDoc}
                            />


                        </div>
                        {caseData && caseData.needApprovalDocument && (
                            <div className="centered-control">
                                <FormControlLabel
                                    control={<Checkbox checked={approveDoc}
                                                       onChange={(e) => {
                                                           setApproveDoc(e.target.checked);
                                                           if (e.target.checked) {
                                                               setShared(true);
                                                           }
                                                       }}
                                    />}
                                    label="დადასტურების დოკუმენტი"
                                />
                            </div>
                        )}


                    </div>
                    <div className="upload-single-footer">
                        <Button style={{width: "100%"}} onClick={() => setIsModalOpen(true)}
                                disabled={!file || isUploading || !fileTitle} variant="contained">
                            {isUploading ? 'ატვირთვა...' : 'დოკუმენტის ატვირთვა'}
                        </Button>
                    </div>
                </div>
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={performUpload}
                />

            </div>
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
        </div>

    );
};

export default UploadSingleFile;
